export default "__VITE_ASSET__7e307485__"